import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/lib/Form';
import Col from 'react-bootstrap/lib/Col';
import { QuestionContainer } from './QuestionContainer';
import { FieldArray } from 'formik';
import { ProjectType } from '../../../utils/enums';

export class ConsultationCategory extends Component {
	render() {
		const name =
			this.props.officeThematicArea && this.props.officeThematicArea.thematicAreaName
				? this.props.officeThematicArea.thematicAreaName
				: '';
		const { maxPoint, questionMaxPoint } = this.props;
		return (
			<React.Fragment>
				<Form.Row className="category">
					<Col>
						{typeof this.props.errors.questions === 'string' && (
							<Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
								{this.props.errors.questions}
							</Form.Control.Feedback>
						)}
						{this.props.projectType === ProjectType.PublicBudget && (
							<Fragment>
								<div className="consultation__info title title--sub title--bottom-10 title--top-10">
									<div className="title__label title__label--primary-dark">Kategoria: </div>
									<div className="title__value">{name}&nbsp;</div>
									{
										// <div className="title__desc">
										// 	(maksymalna ilość punktów do wykorzystania w kategorii - {maxPoint} punktów,
										// 	maksymalna ilość punktów dla pytania - {questionMaxPoint} punktów)
										// </div>
									}
								</div>
								{typeof this.props.errors.maxPoint === 'string' && (
									<Form.Control.Feedback
										type="invalid"
										style={{ display: 'block', color: 'red', marginTop: 10 }}
									>
										{this.props.errors.maxPoint}
									</Form.Control.Feedback>
								)}
							</Fragment>
						)}
						<FieldArray
							id={`${this.props.prefixName}questions`}
							name={`${this.props.prefixName}questions`}
							render={(arrayHelper) => (
								<QuestionContainer
									items={this.props.questions}
									categoryId={this.props.id}
									categoryIndex={this.props.categoryIndex}
									consultationFormType={this.props.consultationFormType}
									isResultPublished={this.props.isResultPublished}
									disabled={this.props.disabled}
									formIndex={this.props.formIndex}
									prefixName={this.props.prefixName}
									loggedUserId={this.props.loggedUserId}
									projectType={this.props.projectType}
									onChange={this.props.onChange}
									onBlur={this.props.onBlur}
									setFieldValue={this.props.setFieldValue}
									errors={this.props.errors}
									isAuth={this.props.isAuth}
									availableVoteNotLogged={this.props.availableVoteNotLogged}
									subQuestion={false}
									isPreview={this.props.isPreview}
								/>
							)}
						/>
					</Col>
				</Form.Row>
			</React.Fragment>
		);
	}
}

ConsultationCategory.propTypes = {
	categoryIndex: PropTypes.number,
	consultationFormType: PropTypes.number,
	disabled: PropTypes.bool,
	formIndex: PropTypes.number,
	id: PropTypes.number,
	isResultPublished: PropTypes.bool,
	loggedUserId: PropTypes.number,
	maxPoint: PropTypes.number,
	prefixName: PropTypes.string,
	projectType: PropTypes.number,
	rowId: PropTypes.number,
	title: PropTypes.string,
	questions: PropTypes.arrayOf(
		PropTypes.shape({
			canComment: PropTypes.bool,
			content: PropTypes.string,
			id: PropTypes.number,
			maxPoint: PropTypes.number,
			order: PropTypes.number,
			questionOptionCount: PropTypes.number,
			questionResultQuantitySum: PropTypes.number,
			questionType: PropTypes.number,
			answers: PropTypes.arrayOf(
				PropTypes.shape({
					categoryId: PropTypes.number,
					id: PropTypes.number,
					questionId: PropTypes.number,
					userId: PropTypes.number,
					answerOptions: PropTypes.arrayOf(
						PropTypes.shape({
							comment: PropTypes.string,
							id: PropTypes.number,
							openDate: PropTypes.string,
							openText: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
							questionMatrixValueId: PropTypes.number,
							questionOptionId: PropTypes.number,
							ranking: PropTypes.number
						})
					)
				})
			),
			questionMatrixValues: PropTypes.arrayOf(
				PropTypes.shape({
					content: PropTypes.string,
					id: PropTypes.number,
					order: PropTypes.number
				})
			),
			questionOptions: PropTypes.arrayOf(
				PropTypes.shape({
					content: PropTypes.string,
					id: PropTypes.number,
					order: PropTypes.number
				})
			),
			questionResults: PropTypes.arrayOf(
				PropTypes.shape({
					id: PropTypes.number,
					quantity: PropTypes.number,
					questionOptionName: PropTypes.string
				})
			)
		})
	),
	errors: PropTypes.object,

	onBlur: PropTypes.func,
	onChange: PropTypes.func,
	setFieldTouched: PropTypes.func,
	setFieldValue: PropTypes.func
};

ConsultationCategory.defaultProps = {
	categoryIndex: 0,
	consultationFormType: 0,
	disabled: false,
	formIndex: 0,
	id: 0,
	isResultPublished: false,
	loggedUserId: 0,
	maxPoint: 0,
	prefixName: '',
	projectType: 0,
	rowId: 0,
	title: '',

	errors: {},

	questions: [],

	onBlur: Function.prototype,
	onChange: Function.prototype,
	setFieldTouched: Function.prototype,
	setFieldValue: Function.prototype
};
